/**
 * Created by Julio Perez on 9/24/2016.
 */

import './map.css';

////ROUTING
import routing from './map-page.routes';

////CONTROLLER
import MapPageController from './map-page.controller';

////DIRECTIVES
import mapPage from './map-page.directive';

////SERVICES
require('leaflet');
import mapLeafletService from './map.leaflet';
import mapTopCountriesService from '../../services/map-top-countries.service'


export default angular
        .module('mapPage', [
            mapPage,
            mapTopCountriesService,
            mapLeafletService
        ])
        .config(routing)
        .controller('MapPageController', MapPageController)
        .name;


// WEBPACK FOOTER //
// ./src/app/views/map-page/index.js